var map = {
	"./404.svg": "./src/config/icons/svg/404.svg",
	"./BrandTelegram.svg": "./src/config/icons/svg/BrandTelegram.svg",
	"./BuildingCommunity.svg": "./src/config/icons/svg/BuildingCommunity.svg",
	"./CoPresentOutlined.svg": "./src/config/icons/svg/CoPresentOutlined.svg",
	"./ControlPointOutlined.svg": "./src/config/icons/svg/ControlPointOutlined.svg",
	"./accountbook.svg": "./src/config/icons/svg/accountbook.svg",
	"./agent.svg": "./src/config/icons/svg/agent.svg",
	"./area.svg": "./src/config/icons/svg/area.svg",
	"./bug.svg": "./src/config/icons/svg/bug.svg",
	"./build.svg": "./src/config/icons/svg/build.svg",
	"./busoutline.svg": "./src/config/icons/svg/busoutline.svg",
	"./button.svg": "./src/config/icons/svg/button.svg",
	"./calendar.svg": "./src/config/icons/svg/calendar.svg",
	"./car.svg": "./src/config/icons/svg/car.svg",
	"./cascader.svg": "./src/config/icons/svg/cascader.svg",
	"./chart.svg": "./src/config/icons/svg/chart.svg",
	"./checkbox.svg": "./src/config/icons/svg/checkbox.svg",
	"./clipboard.svg": "./src/config/icons/svg/clipboard.svg",
	"./code.svg": "./src/config/icons/svg/code.svg",
	"./color.svg": "./src/config/icons/svg/color.svg",
	"./commpie.svg": "./src/config/icons/svg/commpie.svg",
	"./component.svg": "./src/config/icons/svg/component.svg",
	"./customer.svg": "./src/config/icons/svg/customer.svg",
	"./dashboard.svg": "./src/config/icons/svg/dashboard.svg",
	"./dataCenter.svg": "./src/config/icons/svg/dataCenter.svg",
	"./date-range.svg": "./src/config/icons/svg/date-range.svg",
	"./date.svg": "./src/config/icons/svg/date.svg",
	"./dict.svg": "./src/config/icons/svg/dict.svg",
	"./documentation.svg": "./src/config/icons/svg/documentation.svg",
	"./download.svg": "./src/config/icons/svg/download.svg",
	"./drag.svg": "./src/config/icons/svg/drag.svg",
	"./druid.svg": "./src/config/icons/svg/druid.svg",
	"./edit.svg": "./src/config/icons/svg/edit.svg",
	"./education.svg": "./src/config/icons/svg/education.svg",
	"./email.svg": "./src/config/icons/svg/email.svg",
	"./example.svg": "./src/config/icons/svg/example.svg",
	"./excel.svg": "./src/config/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/config/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/config/icons/svg/eye-open.svg",
	"./eye.svg": "./src/config/icons/svg/eye.svg",
	"./finance.svg": "./src/config/icons/svg/finance.svg",
	"./finance_settle.svg": "./src/config/icons/svg/finance_settle.svg",
	"./form.svg": "./src/config/icons/svg/form.svg",
	"./fullscreen.svg": "./src/config/icons/svg/fullscreen.svg",
	"./github.svg": "./src/config/icons/svg/github.svg",
	"./guide.svg": "./src/config/icons/svg/guide.svg",
	"./icon.svg": "./src/config/icons/svg/icon.svg",
	"./input.svg": "./src/config/icons/svg/input.svg",
	"./international.svg": "./src/config/icons/svg/international.svg",
	"./job.svg": "./src/config/icons/svg/job.svg",
	"./language.svg": "./src/config/icons/svg/language.svg",
	"./line.svg": "./src/config/icons/svg/line.svg",
	"./link.svg": "./src/config/icons/svg/link.svg",
	"./list.svg": "./src/config/icons/svg/list.svg",
	"./location.svg": "./src/config/icons/svg/location.svg",
	"./lock.svg": "./src/config/icons/svg/lock.svg",
	"./log.svg": "./src/config/icons/svg/log.svg",
	"./logininfor.svg": "./src/config/icons/svg/logininfor.svg",
	"./logo.svg": "./src/config/icons/svg/logo.svg",
	"./message.svg": "./src/config/icons/svg/message.svg",
	"./money.svg": "./src/config/icons/svg/money.svg",
	"./monitor.svg": "./src/config/icons/svg/monitor.svg",
	"./nested.svg": "./src/config/icons/svg/nested.svg",
	"./number.svg": "./src/config/icons/svg/number.svg",
	"./online.svg": "./src/config/icons/svg/online.svg",
	"./orderlist.svg": "./src/config/icons/svg/orderlist.svg",
	"./password.svg": "./src/config/icons/svg/password.svg",
	"./pdf.svg": "./src/config/icons/svg/pdf.svg",
	"./people.svg": "./src/config/icons/svg/people.svg",
	"./peoples.svg": "./src/config/icons/svg/peoples.svg",
	"./phone.svg": "./src/config/icons/svg/phone.svg",
	"./post.svg": "./src/config/icons/svg/post.svg",
	"./pricemodel.svg": "./src/config/icons/svg/pricemodel.svg",
	"./product.svg": "./src/config/icons/svg/product.svg",
	"./qq.svg": "./src/config/icons/svg/qq.svg",
	"./question.svg": "./src/config/icons/svg/question.svg",
	"./radio.svg": "./src/config/icons/svg/radio.svg",
	"./rate.svg": "./src/config/icons/svg/rate.svg",
	"./redis-list.svg": "./src/config/icons/svg/redis-list.svg",
	"./redis.svg": "./src/config/icons/svg/redis.svg",
	"./row.svg": "./src/config/icons/svg/row.svg",
	"./search.svg": "./src/config/icons/svg/search.svg",
	"./select.svg": "./src/config/icons/svg/select.svg",
	"./server.svg": "./src/config/icons/svg/server.svg",
	"./setting.svg": "./src/config/icons/svg/setting.svg",
	"./shopping.svg": "./src/config/icons/svg/shopping.svg",
	"./size.svg": "./src/config/icons/svg/size.svg",
	"./skill.svg": "./src/config/icons/svg/skill.svg",
	"./slider.svg": "./src/config/icons/svg/slider.svg",
	"./source.svg": "./src/config/icons/svg/source.svg",
	"./star.svg": "./src/config/icons/svg/star.svg",
	"./statis.svg": "./src/config/icons/svg/statis.svg",
	"./swagger.svg": "./src/config/icons/svg/swagger.svg",
	"./switch.svg": "./src/config/icons/svg/switch.svg",
	"./system.svg": "./src/config/icons/svg/system.svg",
	"./tab.svg": "./src/config/icons/svg/tab.svg",
	"./table.svg": "./src/config/icons/svg/table.svg",
	"./textarea.svg": "./src/config/icons/svg/textarea.svg",
	"./theme.svg": "./src/config/icons/svg/theme.svg",
	"./time-range.svg": "./src/config/icons/svg/time-range.svg",
	"./time.svg": "./src/config/icons/svg/time.svg",
	"./tool.svg": "./src/config/icons/svg/tool.svg",
	"./top.svg": "./src/config/icons/svg/top.svg",
	"./tree-table.svg": "./src/config/icons/svg/tree-table.svg",
	"./tree.svg": "./src/config/icons/svg/tree.svg",
	"./upload.svg": "./src/config/icons/svg/upload.svg",
	"./user.svg": "./src/config/icons/svg/user.svg",
	"./validCode.svg": "./src/config/icons/svg/validCode.svg",
	"./wechat.svg": "./src/config/icons/svg/wechat.svg",
	"./zip.svg": "./src/config/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/config/icons/svg sync \\.svg$";